document.addEventListener("DOMContentLoaded", function () {
  const picassoTextColumnElement = document.querySelector(
    ".picasso-text-columns__slider"
  );
  const mediaQuery = window.matchMedia("(max-width: 768px)");

  let flktypicassoTextColumns;
  let flktyTextColumnNav;

  const handleSwitchFlikty = (e) => {
    if (e.matches) {
      // Initialize Flickity for .picasso-text-columns__slider
      flktypicassoTextColumns = new Flickity(".picasso-text-columns__slider", {
        wrapAround: false,
        fade: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: true,
      });

      // Initialize Flickity for .text-column-dots as navigation for .picasso-text-columns__slider
      flktyTextColumnNav = new Flickity(
        ".picasso-text-columns .text-column-dots",
        {
          asNavFor: ".picasso-text-columns__slider",
          prevNextButtons: false,
          contain: true,
          pageDots: false,
        }
      );

      flktypicassoTextColumns.resize();
      flktyTextColumnNav.resize();
    } else if (
      picassoTextColumnElement.classList.contains("flickity-enabled")
    ) {
      // Destroy Flickity instances if they exist
      if (flktypicassoTextColumns) {
        flktypicassoTextColumns.destroy();
        flktypicassoTextColumns = null;
      }
      if (flktyTextColumnNav) {
        flktyTextColumnNav.destroy();
        flktyTextColumnNav = null;
      }
    }
  };

  mediaQuery.addEventListener("change", () => {
    handleSwitchFlikty(mediaQuery);
  });

  handleSwitchFlikty(mediaQuery);
});
